export class Annonce {

    anc_id: string;
    anc_source: string;
    anc_source_id: string;
    anc_origine_id: string;
    anc_origine_psl_id: string;
    anc_psl_exclusivite: string;
    anc_date_exclusivite: string;
    anc_export_site: boolean;
    anc_export_portail: boolean;
    passerelle: any;
    anc_bloquer_publication_jusqu_au: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.anc_id         = data['anc_id'] ? data['anc_id'] : null;
        this.anc_source     = data['anc_source'] ? data['anc_source'] : null;
        this.anc_source_id  = data['anc_source_id'] ? data['anc_source_id'] : null;
        this.anc_psl_exclusivite    = data['anc_psl_exclusivite'] ? data['anc_psl_exclusivite'] : null;
        this.anc_origine_id         = data['anc_origine_id'] ? data['anc_origine_id'] : null;
        this.anc_origine_psl_id     = data['anc_origine_psl_id'] ? data['anc_origine_psl_id'] : null;
        this.anc_date_exclusivite   = data['anc_date_exclusivite'] ? data['anc_date_exclusivite'] : null;
        this.anc_export_site    = (data['anc_export_site'] && data['anc_export_site'] === '1' ? true : false);
        this.anc_export_portail = (data['anc_export_portail'] && data['anc_export_portail'] === '1' ? true : false);
        this.anc_bloquer_publication_jusqu_au = data['anc_bloquer_publication_jusqu_au'] ? data['anc_bloquer_publication_jusqu_au'] : null;

        this.passerelle = data['passerelle'] ? data['passerelle'] : null;
    }

}
